import { Heading, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import RadioControlGroup from "../../../../components/molecule/RadioControlGroup/RadioControlGroup";
import { getIndicatorLevel } from "../../../../services/Indicator/getIndicatorLevel";

interface ClassificationIndicatorFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  watch: UseFormWatch<FieldValues>;
}

const ClassificationIndicatorForm: FC<ClassificationIndicatorFormProps> = ({
  errors,
  control,
  isDisabled,
  watch,
}) => {
  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Classificação
      </Heading>
      <RadioControlGroup
        errors={errors}
        control={control}
        fetchOptions={getIndicatorLevel}
        fieldName="Nível"
        name="indicatorLevelOption"
        isRequired
        isDisabled={isDisabled}
      />
    </Stack>
  );
};

export default ClassificationIndicatorForm;
